// src/schemas/metricTypeValidation.ts
import { z } from 'zod';

export const numberInputSchema = z
  .string()
  .trim()
  .min(1, { message: 'A value is required.' })
  .refine((val) => !isNaN(Number(val)), { message: 'Must be a valid number.' })
  .transform((val) => Number(val))
  .pipe(
    z
      .number()
      .positive({ message: 'Value must be greater than 0.' })
      .max(10000, { message: 'Value exceeds maximum allowed limit.' })
  );

export const scale1To5Schema = z
  .number({ message: 'Please select a value on the scale.' })
  .int({ message: 'Scale value must be a whole number.' })
  .min(1, { message: 'Minimum rating is 1.' })
  .max(5, { message: 'Maximum rating is 5.' });
